import { datadogRum } from '@datadog/browser-rum';

export enum ActionDataType {
  Time,
  Action,
}

export interface BaseActionInputData {
  value: number;
  tags?: Record<string, any>;
}

export const COMMON_ACTION_TAGS = {
  ENVIRONMENT: 'environment',
} as const;

export default abstract class CustomAction<
  TInputData extends BaseActionInputData = BaseActionInputData,
> {
  abstract name: string;

  abstract type: ActionDataType;

  getRumContext(
    numericAttributes: Record<string, number>,
    stringTags: Record<string, string>,
    value: number,
  ): object {
    if (this.type === ActionDataType.Time) {
      return {
        actionName: this.name,
        time_ms: value,
        ...stringTags,
      };
    }
    return {
      actionName: this.name,
      value,
      ...stringTags,
      ...numericAttributes,
    };
  }

  abstract prepareTags(input: TInputData): Record<string, any>;

  sendAction(input: TInputData): void {
    const env = process.env.NODE_ENV || 'development';
    const stringTags: Record<string, string> = {};
    const numericAttributes: Record<string, number> = {};

    const tags = this.prepareTags(input);
    // Separate string tags from numeric attributes
    Object.entries(tags).forEach(([key, val]) => {
      if (typeof val === 'number') {
        numericAttributes[key] = val;
      } else {
        stringTags[key] = String(val);
      }
    });

    // Add environment as a string tag
    stringTags[COMMON_ACTION_TAGS.ENVIRONMENT] = env;

    const context = this.getRumContext(numericAttributes, stringTags, input.value);
    datadogRum.addAction(this.name, context);
  }
}
